import { Button } from '@protoss/ui';
import { Link } from 'react-router-dom';
import './not-found-page.css';

export function NotFoundPage() {
  return (
    <div className="not-found">
      <h1 className="not-found__code">404</h1>
      <p className="not-found__message">Page not found</p>
      <Link to="/">
        <Button variant="primary" size="md">
          Go Home
        </Button>
      </Link>
    </div>
  );
}
